<template>
  <HeaderPage>
    <div class="container">
      <br>
      <h1>Inventaires</h1>
      <!-- Bouton toujours visible pour créer un nouvel inventaire -->
      <div class="text-center mb-4">
        <button @click="openCreateModal" class="btn btn-primary create-article-btn">
          <i class="fas fa-plus"></i> Créer un nouvel inventaire
        </button>
      </div>

      <div class="text-center mb-3">
        <label for="searchMoisAnnee" class="form-label"></label>
        <input  type="month" id="searchMoisAnnee" v-model="searchMoisAnnee" class="form-control" style="max-width: 300px; display: inline-block;">
      </div>

      <!-- Affichage de la liste de tous les inventaires -->
      <div v-if="filteredInventories.length > 0" class="mt-4">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Mois</th>
              <th>Année</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="inventaire in inventories" :key="inventaire.id">
              <td>{{ moisNoms[inventaire.mois - 1] }}</td>
              <td>{{ inventaire.annee }}</td>
              <td>
  <span
    :class="[
      'badge',
      'px-3',
      'py-2',
      'rounded-pill',
      inventaire.statut === 'valide' ? 'bg-success text-white' : 'bg-danger text-white'
    ]"
  >
    {{ inventaire.statut === 'valide' ? 'Valide' : 'Non validé' }}
  </span>
</td>

              <td>
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-primary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" @click="openDetailsModal(inventaire)" title="Détails">
                        <i class="fas fa-eye"></i> Détails
                      </a>
                    </li>
                    <li v-if="inventaire.statut !== 'valide'">
                      <a class="dropdown-item" @click="openAddArticleModal(inventaire)" title="Ajouter un article">
                        <i class="bi bi-plus-lg"></i> Ajouter un article
                      </a>
                    </li>
                    <li v-if="inventaire.statut !== 'valide'">
                      <a class="dropdown-item" @click="validateInventory(inventaire)" title="Valider">
                        <i class="bi bi-check-lg"></i> Valider
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
      <div v-else class="mt-4">
        <p>Aucun inventaire n'a été créé.</p>
      </div>
    </div>

    <!-- Modal pour créer un inventaire (mois, année et statut) -->
    <div class="modal fade" id="createInventaireModal" tabindex="-1" ref="createModalRef" aria-labelledby="createInventaireModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createInventaireModalLabel">Créer un inventaire</h5>
            <button type="button" class="btn-close" @click="closeCreateModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="moisAnnee" class="form-label">Mois et Année</label>
              <!-- Input de type "month" qui retourne le format "YYYY-MM" -->
              <input type="month" id="moisAnnee" v-model="form.moisAnnee" class="form-control" required>
            </div>
            <div class="mb-3">
              <label for="statutInventaire" class="form-label">Statut</label>
              <select id="statutInventaire" v-model="form.statut" class="form-select" required>
                <option value="nonvalide">Non valide</option>
                <option value="valide">Valide</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeCreateModal">Annuler</button>
            <button type="button" class="btn btn-primary" @click="createInventaire">Enregistrer</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pour ajouter un article dans un inventaire -->
    <div class="modal fade" id="addArticleModal" tabindex="-1" ref="addArticleModalRef" aria-labelledby="addArticleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addArticleModalLabel">Ajouter un article dans l'inventaire</h5>
            <button type="button" class="btn-close" @click="closeAddArticleModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Formulaire d'ajout d'article (sans champ statut) -->
            <div class="mb-3">
              <label for="articleSelect" class="form-label">Article</label>
              <select id="articleSelect" v-model="articleForm.idArticles" class="form-select" required>
                <option value="" disabled>Choisissez un article</option>
                <option v-for="article in articles" :key="article.id" :value="article.id">
                  {{ article.nom_article }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="quantiteArticle" class="form-label">Quantité</label>
              <input type="number" id="quantiteArticle" v-model="articleForm.quantite" class="form-control" required>
            </div>
            <div class="mb-3">
              <label for="causeArticle" class="form-label">Cause</label>
              <input type="text" id="causeArticle" v-model="articleForm.cause" class="form-control" required>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeAddArticleModal">Annuler</button>
            <button type="button" class="btn btn-primary" @click="addArticle">Enregistrer</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pour afficher les détails de l'inventaire sous forme de tableau -->
    <div class="modal fade" id="detailsModal" tabindex="-1" ref="detailsModalRef" aria-labelledby="detailsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="detailsModalLabel">Détails de l'inventaire</h5>
            <button type="button" class="btn-close" @click="closeDetailsModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Article</th>
                  <th>Quantité</th>
                  <th>Cause</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, idx) in selectedDetailsInventory?.details || []" :key="idx">
                  <td>{{ getArticleName(detail.idArticles) }}</td>
                  <td>{{ detail.quantite }}</td>
                  <td>{{ detail.cause }}</td>
                </tr>
                <tr v-if="!selectedDetailsInventory?.details || selectedDetailsInventory.details.length === 0">
                  <td colspan="3" class="text-center">Aucun article</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDetailsModal">Fermer</button>
          </div>
        </div>
      </div>
    </div>

  </HeaderPage>
</template>

<script setup>
import { ref, reactive, onMounted,computed } from 'vue';
import axios from 'axios';
import HeaderPage from './components/HeaderPage.vue';
import { Modal } from 'bootstrap';

const searchMoisAnnee = ref('');
const moisNoms = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
];


const API_URL = process.env.VUE_APP_API_URL;

// Références pour les modals
const createModalRef = ref(null);
let modalInstance = null;

const addArticleModalRef = ref(null);
let addArticleModalInstance = null;

const detailsModalRef = ref(null);
let detailsModalInstance = null;

// Formulaire pour créer un inventaire (mois, année et statut)
const form = reactive({
  moisAnnee: '',
  statut: 'nonvalide'
});

// Tableau de tous les inventaires récupérés depuis la BDD
const inventories = ref([]);

// Inventaire sélectionné pour l'ajout d'un article
const selectedInventory = ref(null);

// Inventaire sélectionné pour afficher les détails
const selectedDetailsInventory = ref(null);

// Formulaire pour ajouter un article dans un inventaire (sans champ statut)
const articleForm = reactive({
  idArticles: '',
  quantite: '',
  cause: ''
});

const articles = ref([]);

// Ouvre la modal de création d'inventaire
const openCreateModal = () => {
  if (!modalInstance) {
    modalInstance = new Modal(createModalRef.value);
  }
  modalInstance.show();
};

const closeCreateModal = () => {
  if (modalInstance) {
    modalInstance.hide();
  }
};

// Crée un nouvel inventaire en appelant l'API
const createInventaire = async () => {
  if (!form.moisAnnee) return;
  const [annee, mois] = form.moisAnnee.split('-');
  
  try {
    const response = await axios.post(`${API_URL}/api/Insertinventaires`, {
      mois: parseInt(mois, 10),
      annee: parseInt(annee, 10),
      statut: form.statut
    });
    // Ajoute l'inventaire créé à la liste
    inventories.value.push(response.data);
    closeCreateModal();
    form.moisAnnee = '';
    form.statut = 'nonvalide';
  } catch (error) {
    console.error("Erreur lors de la création de l'inventaire", error);
  }
};

// Ouvre la modal d'ajout d'article en sélectionnant l'inventaire concerné
const openAddArticleModal = (inventaire) => {
  selectedInventory.value = inventaire;
  if (!addArticleModalInstance) {
    addArticleModalInstance = new Modal(addArticleModalRef.value);
  }
  addArticleModalInstance.show();
};

const closeAddArticleModal = () => {
  if (addArticleModalInstance) {
    addArticleModalInstance.hide();
  }
};

// Ajoute un article à l'inventaire sélectionné en appelant l'API
const addArticle = async () => {
  if (!selectedInventory.value || !articleForm.idArticles) return;
  
  try {
    const response = await axios.post(`${API_URL}/api/inventaires/${selectedInventory.value.id}/articles`, {
      idArticles: articleForm.idArticles,
      quantite: articleForm.quantite,
      cause: articleForm.cause
    });
    // Ajoute le nouvel article aux détails de l'inventaire sélectionné
    if (!selectedInventory.value.details) {
      selectedInventory.value.details = [];
    }
    selectedInventory.value.details.push(response.data);
    
    // Réinitialise le formulaire d'article
    articleForm.idArticles = '';
    articleForm.quantite = '';
    articleForm.cause = '';
    closeAddArticleModal();
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'article", error);
  }
};

// Ouvre la modal pour afficher les détails de l'inventaire
const openDetailsModal = (inventaire) => {
  selectedDetailsInventory.value = inventaire;
  if (!detailsModalInstance) {
    detailsModalInstance = new Modal(detailsModalRef.value);
  }
  detailsModalInstance.show();
};

const closeDetailsModal = () => {
  if (detailsModalInstance) {
    detailsModalInstance.hide();
  }
};

// Fonction pour valider un inventaire
const validateInventory = async (inventaire) => {
  try {
    await axios.put(`${API_URL}/api/inventaires/${inventaire.id}/valider`);
    // Met à jour le statut localement
    inventaire.statut = 'valide';
  } catch (error) {
    console.error("Erreur lors de la validation de l'inventaire", error);
  }
};

// Récupère la liste des inventaires depuis la base de données
const loadInventoriesFromDB = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/getInventaires`);
    inventories.value = response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des inventaires", error);
  }
};

// Récupère la liste des articles depuis l'API
const fetchArticles = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/users/articles`);
    articles.value = response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des articles", error);
  }
};

// Méthode d'aide pour obtenir le nom d'un article à partir de son id
const getArticleName = (id) => {
  const article = articles.value.find(item => item.id === id);
  return article ? article.nom_article : 'N/A';
};

// Filtrage des inventaires en fonction du mois et de l'année recherchés
const filteredInventories = computed(() => {
  if (!searchMoisAnnee.value) {
    return inventories.value;
  }
  const [annee, mois] = searchMoisAnnee.value.split('-').map(Number);
  return inventories.value.filter(inventaire => 
    inventaire.annee === annee && inventaire.mois === mois
  );
});

onMounted(() => {
  loadInventoriesFromDB();
  fetchArticles();
});
</script>

<style scoped>
.create-article-btn {
  width: 180px;
}
.table {
  margin-top: 20px;
  width: 100%;
}
</style>
